import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClergyBioChurchReport, getClergyBioEcclesiastics, getClergyBioEducation, getClergyBioMinistry, getClergyBioPersonInfo, getClergyBioProfessional, getClergyBioRelationships, getClergyBioVolunteer } from '../../global/ducks/clergy-bio-api';
import { TcsmStates } from '../../root/tcsm-model';
import { setClergyBioChurchReport, setClergyBioEcclesiastics, setClergyBioEducation, setClergyBioMinistries, setClergyBioPersonalInfo, setClergyBioProfessional, setClergyBioRelationship, setClergyBioVolunteer, setLoadingState } from './clergy-bio-slice';
import { DataState, LoadingState } from './model/clergy-bio-app-models';

export function useClergyBioInfo(guid: string) {
	const dispatch = useDispatch();
	const loadingState = useSelector<TcsmStates, LoadingState>(state => state.clergyBioState.loaded);

	useEffect(() => {
		if (loadingState?.personInfo === DataState.EMPTY) {
			dispatch(setLoadingState(DataState.LOADING, 'personInfo'));
			dispatch(getClergyBioPersonInfo(
				guid,
				(data) => dispatch(setClergyBioPersonalInfo(data?.data)),
				() => dispatch(setLoadingState(DataState.ERROR, 'personInfo'))),
			);
		}
		if (loadingState?.churchReport === DataState.EMPTY) {
			dispatch(setLoadingState(DataState.LOADING, 'churchReport'));
			dispatch(getClergyBioChurchReport(
				guid,
				(data) => dispatch(setClergyBioChurchReport(data?.data)),
				() => dispatch(setLoadingState(DataState.ERROR, 'churchReport'))),
			);
		}
		if (loadingState?.education === DataState.EMPTY) {
			dispatch(setLoadingState(DataState.LOADING, 'education'));
			dispatch(getClergyBioEducation(
				guid,
				(data) => dispatch(setClergyBioEducation(data?.data)),
				() => dispatch(setLoadingState(DataState.ERROR, 'education'))),
			);
		}
		if (loadingState?.ministries === DataState.EMPTY) {
			dispatch(setLoadingState(DataState.LOADING, 'ministries'));
			dispatch(getClergyBioMinistry(
				guid,
				(data) => dispatch(setClergyBioMinistries(data?.data)),
				() => dispatch(setLoadingState(DataState.ERROR, 'ministries'))),
			);
		}
		if (loadingState?.professional === DataState.EMPTY) {
			dispatch(setLoadingState(DataState.LOADING, 'professional'));
			dispatch(getClergyBioProfessional(
				guid,
				(data) => dispatch(setClergyBioProfessional(data?.data)),
				() => dispatch(setLoadingState(DataState.ERROR, 'professional'))),
			);
		}
		if (loadingState?.volunteer === DataState.EMPTY) {
			dispatch(setLoadingState(DataState.LOADING, 'volunteer'));
			dispatch(getClergyBioVolunteer(
				guid,
				(data) => dispatch(setClergyBioVolunteer(data?.data)),
				() => dispatch(setLoadingState(DataState.ERROR, 'volunteer'))),
			);
		}
		if (loadingState?.relationship === DataState.EMPTY) {
			dispatch(setLoadingState(DataState.LOADING, 'relationship'));
			dispatch(getClergyBioRelationships(
				guid,
				(data) => dispatch(setClergyBioRelationship(data?.data)),
				() => dispatch(setLoadingState(DataState.ERROR, 'relationship'))),
			);
		}
		if (loadingState?.ecclesiastics === DataState.EMPTY) {
			dispatch(setLoadingState(DataState.LOADING, 'ecclesiastics'));
			dispatch(getClergyBioEcclesiastics(
				guid, (data) => dispatch(setClergyBioEcclesiastics(data?.data)),
				() => dispatch(setLoadingState(DataState.ERROR, 'ecclesiastics'))),
			);
		}
	}, []);

	return loadingState;
}